import { Show } from '@ariksa/compliance-policies/api';
import { Box } from '@chakra-ui/react';
import { customTheme } from 'theme';

const renderBox = color => (
  <Box
    boxSize={3}
    border="1px solid"
    bg={color}
    borderRadius={4}
    borderColor={customTheme.colors.gray['200']}
  />
);

export const compliancePolicyStatusOptions = [
  { label: 'Pass', value: Show.Passed, icon: renderBox('green.300') },
  { label: 'Fail', value: Show.Failed, icon: renderBox('red.300') },
];
